import { ContentCenter } from './styles';
import Logo from '@/components/ui/icons/Logo';
import ResponsiveGrid from '@/components/ui/ResponsiveGrid';
import Section from '@/components/ui/Section';

const NotFoundPage = () => (
  <Section bgColor="white" minHeight="auto">
    <ResponsiveGrid>
      <ContentCenter>
        <h1>PAGE NOT FOUND</h1>
        <p>
          {`The page you're looking for does not exist,`}
          <br />
          {`or we couldn't find the right box for it.`}
        </p>
        <Logo title="Foxbox Digital Logo" style={{ width: '80px' }} />
      </ContentCenter>
    </ResponsiveGrid>
  </Section>
);

export default NotFoundPage;
